import React from "react";
import { connect } from "react-redux";
import Axios from "Source/axiosPool";
import Select from "Components/common/Select/Select";
import Avatar from "Components/common/Avatar/Avatar";

@connect(store => {
    return {
        project: store.project,
        loggedUser: store.loggedUser
    }
})

class FieldProjectLead extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            users: [],
            searchIsLoading: false
        }

        _.map(["onOpen", "onRenderOption", "onChange"], fn => {
            this[fn] = this[fn].bind(this);
        });
    }

    onOpen() {
        const { project } = this.props;
        const url = `api/projects/${project.Selected.id}/members`;

        this.setState({
            ...this.state,
            searchIsLoading: true
        });

        if (this.props.onLeadOpen) {
            this.props.onLeadOpen();
        }

        Axios.get(url)
            .then(response => {
                if (response.data) {
                    this.setState({
                        ...this.state,
                        searchIsLoading: false,
                        users: response.data
                            .filter(u => u.user && u.user["user-type"] === "Internal")
                            .map(u => ({
                                value: u.user.id,
                                label: `${u.user["first-name"]} ${u.user["last-name"]}`
                            }))
                    });
                }
            });
    }

    onRenderOption(option) {
        return (
            <div class="lead-option">
                <div class="lead-container">
                    <Avatar id={option.value} name={option.label}  disableTooltip={true} />
                    <span>{option.label}</span>
                </div>
            </div>
        )
    }

    onChange(option) {
        if( this.props.onChange ) {
            this.props.onChange({ target: { id: "workstreamLead", value: option ? option : {} }});
        }
    }

    render() {
        return (
            <Select 
                isSearchable={true}
                classes={{options: `addUsersOption accountLeadOption`}}
                placeholder="Search"
                options={this.state.users}
                onChange={this.onChange}
                onClearSelected={this.onChange}
                onOpen={this.onOpen}
                isLoading={this.state.searchIsLoading}
                isClose={this.props.isClose}
                selected={this.props.selected}
                count={10}
                renderOption={this.onRenderOption}
                renderSelected={this.onRenderOption}
                isFirstItemSelected={false}
                searchIcon={<i class="material-icons">search</i>}
            />
        );
    }
}

export default FieldProjectLead;
